import {
  AnnouncementContextMenuItems,
  AnnouncementContextMenuType,
} from 'enums/app'
import { useCallback, useMemo } from 'react'
import { useTranslation } from '@crew/modules/i18n'
import {
  useMarkAllReadMutation,
  useUpdateAnnouncementReadMutation,
} from '@crew/apis/announcement/announcementApis'

// 型を明示的に定義
type ContextMenuItem = {
  id: string
  name: string
}

export const useAnnouncementContextMenu = (
  contextMenuType: AnnouncementContextMenuType
) => {
  const [markAllReadMutation] = useMarkAllReadMutation()
  const [updateAnnouncementReadMutation] = useUpdateAnnouncementReadMutation()

  const { t } = useTranslation()
  const contextMenuData = useMemo(() => {
    return Object.values(AnnouncementContextMenuItems)
      .filter((item) => {
        if (contextMenuType === AnnouncementContextMenuType.ForAll) {
          // お知らせ一覧の上部に表示される三点リーダーの場合は、「すべて既読」のみ表示する
          return item === AnnouncementContextMenuItems.AllRead
        } else if (contextMenuType === AnnouncementContextMenuType.ForSingle) {
          // お知らせ一覧の各メッセージに表示される三点リーダーの場合は、「すべて既読」以外を表示
          return item !== AnnouncementContextMenuItems.AllRead
        }
        return false
      })
      .map(
        (item): ContextMenuItem => ({
          id: item.action,
          name: t(item.label),
        })
      )
  }, [contextMenuType, t])

  // 「すべて既読にする」
  const markAllRead = useCallback(async () => {
    await markAllReadMutation().unwrap()
  }, [markAllReadMutation])

  // 「既読にする」「未読にする」
  const updateAnnouncementRead = useCallback(
    async (announcementId: string, isRead: boolean) => {
      await updateAnnouncementReadMutation({
        announcementId,
        isRead,
      }).unwrap()
    },
    [updateAnnouncementReadMutation]
  )

  return {
    contextMenuData,
    markAllRead,
    updateAnnouncementRead,
  }
}
